import DMVOfficesMap from '../services/DMVOfficesMap';

export default {
  init() {
    const el = '#map';
    const offices = null;
    const zoom = 15;
    const OfficesMap = new DMVOfficesMap(el, offices, zoom);
    OfficesMap.render();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-office.js